// Fichier généré automatiquement par scripts/generate-version.mjs — ne pas éditer à la main.
export const APP_VERSION = 'v2.14.0';
